"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aesDecrypt = exports.md5Encrypt = exports.capitalize = exports.unCamelCase = exports.hmac = exports.encryptWithRSAKey = exports.decryptApiSecret = exports.encryptAESKey = exports.random32String = void 0;
const CryptoJS = require("crypto-js");
const jsencrypt_1 = require("jsencrypt");
function random32String() {
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let pwd = '';
    for (let i = 0; i < 32; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return pwd;
}
exports.random32String = random32String;
function encryptAESKey(rsaPublicKey, aesKey) {
    let encrypt = new jsencrypt_1.JSEncrypt();
    encrypt.setPublicKey(rsaPublicKey);
    return encrypt.encrypt(aesKey);
}
exports.encryptAESKey = encryptAESKey;
function decryptApiSecret(secret, aesKey) {
    return CryptoJS.AES.decrypt(secret, CryptoJS.enc.Utf8.parse(aesKey), {
        keySize: 32,
        iv: CryptoJS.enc.Utf8.parse(aesKey),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
}
exports.decryptApiSecret = decryptApiSecret;
function encryptWithRSAKey(rsaPublicKey, data) {
    let encrypt = new jsencrypt_1.JSEncrypt();
    encrypt.setPublicKey(rsaPublicKey);
    return encrypt.encrypt(data);
}
exports.encryptWithRSAKey = encryptWithRSAKey;
function hmac(request, secret, hash = 'sha256', digest = 'base64') {
    const result = CryptoJS['Hmac' + hash.toUpperCase()](request, secret);
    if (digest) {
        const encoding = (digest === 'binary') ? 'Latin1' : capitalize(digest);
        return result.toString(CryptoJS.enc[capitalize(encoding)]);
    }
    return result;
}
exports.hmac = hmac;
function unCamelCase(s) {
    return s.match(/^[A-Z0-9_]+$/) ? s : (s.replace(/[a-z0-9][A-Z]/g, x => x[0] + '_' + x[1]).replace(/[A-Z0-9][A-Z0-9][a-z]/g, x => x[0] + '_' + x[1] + x[2]).toLowerCase());
}
exports.unCamelCase = unCamelCase;
function capitalize(s) {
    return s.length ? (s.charAt(0).toUpperCase() + s.slice(1)) : s;
}
exports.capitalize = capitalize;
function md5Encrypt(ciphertext) {
    return CryptoJS.MD5(ciphertext).toString();
}
exports.md5Encrypt = md5Encrypt;
function aesDecrypt(key, iv, data) {
    key = CryptoJS.enc.Utf8.parse(key);
    iv = CryptoJS.enc.Utf8.parse(iv);
    const option = {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    };
    return CryptoJS.AES.decrypt(data, key, option).toString(CryptoJS.enc.Utf8);
}
exports.aesDecrypt = aesDecrypt;
